export const GraphType = Object.freeze({
  ELEVATION_DISTANCE: 'elevationDistance',
  SLOPE_DISTANCE: 'slopeDistance',
  ELEVATION_PROFILE: 'eleProfile',
});

export const LineTypes = Object.freeze({
  ORIGINAL: 'original',
  SMOOTHED: 'modified'
});

export const UnitType = Object.freeze({
  METRIC: 'metric',
  IMPERIAL: 'imperial'
});


